import { render, staticRenderFns } from "./Stocktakes.vue?vue&type=template&id=6ef1c0e8&scoped=true&"
import script from "./Stocktakes.vue?vue&type=script&lang=js&"
export * from "./Stocktakes.vue?vue&type=script&lang=js&"
import style0 from "./Stocktakes.vue?vue&type=style&index=0&id=6ef1c0e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef1c0e8",
  null
  
)

export default component.exports